<template>
  <div>
    <scholar-profile v-if="$route.params.profileType == 'SCHOLAR'" />
    <tf-profile
      v-if="
        $route.params.profileType == 'VENDOR' ||
        $route.params.profileType == 'TF'
      "
    />
  </div>
</template>

<script>
import scholarProfile from "./scholarProfile.vue";
import TfProfile from "./tfProfile.vue";
export default {
  components: { scholarProfile, TfProfile },
  name: "mainProfile",
};
</script>

<style></style>
